import { defineMessages, enPlural, ruPlural } from '@/i18n'

/** Тексты диалога отрисовки картинок: ручной выбор мест и авто-план. */
export const messages = defineMessages({
  ru: {
    drawnHint: (total: number, drawn: number) => `мест: ${total}, нарисовано ${drawn}`,
    sourceLang: 'Основной язык',
    secondLang: 'Второй язык',
    secondLangLater:
      'Второй язык появится, когда у курса будет перевод — запустите его из меню языка в шапке.',
    courseBanner: 'Баннер курса',
    mascots: 'Маскоты',
    overwrite: 'Перерисовать уже нарисованные',
    overwriteWarning:
      'Прежняя картинка заменится: ссылка сменится, старый файл останется в хранилище.',
    targetsFailed: 'места не загрузились',
    retry: 'Повторить',
    noPrompts: 'промптов нет',
    willSkip: (n: number) => ` · будет пропущено ${n}`,
    selected: (n: number) => `Выбрано мест: ${n}`,
    price: (cost: string) => `Цена: ${cost}`,
    balance: (balance: string) => ` · Баланс: ${balance}`,
    notEnoughCredits: 'не хватает кредитов',
    overLimit: (n: number) => `Не помещается в один запуск — снимите ${n}, иначе запуск отобьётся.`,
    toDraw: 'К отрисовке: ',
    pilotOffer: (variants: number, cost: string) =>
      `Сначала подобрать стиль — ${variants} ${ruPlural(variants, 'вариант', 'варианта', 'вариантов')} первой картинки, ${cost}.`,
    pilotPaidAll: 'Платятся все нарисованные варианты, включая те, которые вы не выберете.',
    nothingToDraw:
      'Все картинки исходного языка уже нарисованы либо у мест нет промптов. Выберите места вручную, если нужно перерисовать уже нарисованное.',
    modeAuto: 'Нарисовать всё',
    modeManual: 'Выбрать места',
  },
  en: {
    drawnHint: (total: number, drawn: number) =>
      `${total} ${enPlural(total, 'spot', 'spots')}, ${drawn} generated`,
    sourceLang: 'Source language',
    secondLang: 'Second language',
    secondLangLater:
      'The second language will appear once the course has a translation — start it from the language menu in the header.',
    courseBanner: 'Course banner',
    mascots: 'Mascots',
    overwrite: 'Regenerate existing images',
    overwriteWarning:
      'The old image will be replaced: its link changes, and the old file stays in storage.',
    targetsFailed: 'spots didn’t load',
    retry: 'Retry',
    noPrompts: 'no prompts',
    willSkip: (n: number) => ` · ${n} will be skipped`,
    selected: (n: number) => `Spots selected: ${n}`,
    price: (cost: string) => `Price: ${cost}`,
    balance: (balance: string) => ` · Balance: ${balance}`,
    notEnoughCredits: 'not enough credits',
    overLimit: (n: number) => `Too many for one run — remove ${n}, or the run will be rejected.`,
    toDraw: 'To generate: ',
    pilotOffer: (variants: number, cost: string) =>
      `Pick a style first — ${variants} ${enPlural(variants, 'variant', 'variants')} of the first image, ${cost}.`,
    pilotPaidAll: 'You pay for every generated variant, including the ones you don’t pick.',
    nothingToDraw:
      'All source-language images are already generated, or the spots have no prompts. Pick spots manually if you want to regenerate existing images.',
    modeAuto: 'Generate all',
    modeManual: 'Pick spots',
  },
})
